import { useMemo } from "react";

import {
  AVIATION_RISK_TARGET_OPTIONS,
  AVIATION_SCOPE_MULTI_OPTIONS,
  AVIATION_WIZARD_STEPS,
  DEFAULT_PROFILE_SLUG_BY_FAMILY,
  FAMILY_TO_ACTIVITY_DOMAINS,
  PRIMARY_ACTIVITY_FAMILY_BLURBS,
  PRIMARY_ACTIVITY_FAMILY_OPTIONS,
  REFINED_PROFILE_OPTIONS_BY_FAMILY,
  mapTaxonomyToWizardConfig,
  taxonomyResponseToWizardConfig,
} from "@utils/aviationWizardConfig";

import { useAviationWizardTaxonomy } from "./useAviationWizardTaxonomy";

export type AviationWizardConfigView = ReturnType<typeof mapTaxonomyToWizardConfig>;

const STATIC_AVIATION_WIZARD_CONFIG: AviationWizardConfigView = {
  wizardSteps: AVIATION_WIZARD_STEPS,
  primaryActivityFamilyOptions: PRIMARY_ACTIVITY_FAMILY_OPTIONS,
  primaryActivityFamilyBlurbs: PRIMARY_ACTIVITY_FAMILY_BLURBS,
  refinedProfileOptionsByFamily: REFINED_PROFILE_OPTIONS_BY_FAMILY,
  scopeMultiOptions: AVIATION_SCOPE_MULTI_OPTIONS,
  riskTargetOptions: AVIATION_RISK_TARGET_OPTIONS,
  defaultProfileSlugByFamily: DEFAULT_PROFILE_SLUG_BY_FAMILY,
  familyToActivityDomains: FAMILY_TO_ACTIVITY_DOMAINS,
};

/** Load Rules API taxonomy and map to wizard render config (static fallback until loaded). */
export function useAviationWizardConfig(enabled: boolean, countryCode = "USA") {
  const { taxonomy, loading, error, reload } = useAviationWizardTaxonomy(
    enabled,
    countryCode,
  );

  const config = useMemo(() => {
    if (!taxonomy) {
      return STATIC_AVIATION_WIZARD_CONFIG;
    }
    return mapTaxonomyToWizardConfig(taxonomyResponseToWizardConfig(taxonomy));
  }, [taxonomy]);

  return { config, taxonomy, loading, error, reload };
}
